import React, { createContext, useContext, ReactNode } from 'react';
import ApiClient from '../../lib/api-client'
import { IPermissionDTO } from '@common-frontend-submodule/interfaces/permission/ipermission.interface'
import { IApiResponseGenericDTO } from '@common-frontend-submodule/interfaces/common/iapi-response.interface'
import { PermissionRoutes } from '@common-frontend-submodule/enums/routes/permission-routes.enum'

const apiClient = ApiClient.getInstance()

interface PermissionContextProps {
  getById: (permissionId: string) => Promise<IApiResponseGenericDTO<IPermissionDTO>>;
  getAll: () => Promise<IApiResponseGenericDTO<IPermissionDTO[]>>;
}

const PermissionContext = createContext<PermissionContextProps | undefined>(undefined);

export const PermissionsProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const getById = async (permissionId: string): Promise<IApiResponseGenericDTO<IPermissionDTO>> => {
    return await apiClient.getRequest<IPermissionDTO>(`${PermissionRoutes.BasePrefix}/${permissionId}`)
  }
  const getAll = async (): Promise<IApiResponseGenericDTO<IPermissionDTO[]>> => {
    return await apiClient.getRequest<IPermissionDTO[]>(PermissionRoutes.BasePrefix)
  }

  return (
    <PermissionContext.Provider value={{ getById, getAll }}>
      {children}
    </PermissionContext.Provider>
  );
};

export const usePermissionStore = () => {
  const context = useContext(PermissionContext);
  if (!context) {
    throw new Error('usePermissionStore must be used within a PermissionProvider');
  }
  return context;
};